import React, { useContext, useEffect } from "react";

import { AuthContext } from "features/Auth";
import UserTestingInfo from "features/UserTestingInfo";
import CreateOrganizationModal from "features/CreateOrganizationModal";

import Layout from "hoc/Layout";

import Routes from "components/Routes";
import Loading from "components/Loading";
import TourReplayHint from "components/TourReplayHint";

import "./App.scss";
import "assets/styles/index.scss";
import "assets/styles/print.scss";

const App = ({ loading, checkUserSession, lastActivity, loadedUid, fetchUserOrganization, organization }) => {
    const { user, setUser, setPending } = useContext(AuthContext);
    const { uid, metadata: { lastSignInTime = "" } = {} } = user || {};

    //only handling a single org at the moment
    const { primaryOrg = null, ...restMemberOrgIds } = organization?.memberOrgIds || {};
    const orgIdToFetch = primaryOrg || Object.keys(restMemberOrgIds)[0] || "";
    const hasOrgDetails = Boolean(organization?.details);

    // Depending on the whole organization object re-ran this on every change to that slice,
    // including the loading flag this very fetch sets first, which re-entered the effect before
    // the read came back. The id and "do we have it yet" are what the fetch actually turns on.
    useEffect(() => {
        if (uid && orgIdToFetch && !hasOrgDetails) {
            fetchUserOrganization(uid, orgIdToFetch);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [uid, orgIdToFetch, hasOrgDetails]);

    if (loading) return <Loading message="I am loading" />;

    return (
        <>
            {loadedUid && <UserTestingInfo />}
            {loadedUid && <CreateOrganizationModal />}
            <TourReplayHint />
            <Layout user={user}>
                <Routes />
            </Layout>
        </>
    );
};

export default App;
